import {
  FilterTypeEnum,
  FilterUIPlacementEnum,
  IFilterConfig,
  FilterOffer,
  FilterSelection,
} from './types';

// TODO: add translation string keys and initialFilterState market config here later

export const getFiltersConfig = (): IFilterConfig[] => {
  return [
    // {
    //   type: FilterTypeEnum.PRICES_INC_SHIPPING,
    //   placement: FilterUIPlacementEnum.OFFERLIST_HEADER,
    // },
    {
      enabled: false,
      type: FilterTypeEnum.IN_STOCK,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer && offer.stock?.status === 'in_stock');
      },
      missingInfoFn: (offer: FilterOffer) => {
        return Boolean(
          !offer?.stock?.status || offer?.stock?.status === 'unknown'
        );
      },
      filterAlternativeOffers: true,
    },
    {
      enabled: false,
      type: FilterTypeEnum.FEATURED_SHOP,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      filterFn: (offer: FilterOffer) => {
        return Boolean(offer && 'store' in offer && offer.store?.featured);
      },
      filterAlternativeOffers: false,
    },
    {
      enabled: false,
      type: FilterTypeEnum.AUTHORIZED_DEALER,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      filterFn: (offer: FilterOffer) => {
        return Boolean(
          offer && 'authorizedDealer' in offer && offer.authorizedDealer
        );
      },
      filterAlternativeOffers: false,
    },
    {
      enabled: false,
      type: FilterTypeEnum.PRIMARY_MARKET,
      placement: FilterUIPlacementEnum.FILTER_MENU,
      filterFn: (offer: FilterOffer) => {
        return Boolean(
          offer && 'store' in offer && offer.store?.market === 'primary'
        );
      },
      filterAlternativeOffers: false,
    },
    {
      enabled: false,
      type: FilterTypeEnum.VARIANT_SIZE,
      placement: FilterUIPlacementEnum.PRODUCT_HEADER,
      filterFn: (offer: FilterOffer, selection?: FilterSelection) => {
        return Boolean(
          offer &&
            offer?.variantInfo?.size &&
            selection?.includes(offer.variantInfo.size)
        );
      },
      missingInfoFn: (offer: FilterOffer, selection?: FilterSelection) => {
        return !offer?.variantInfo?.size;
      },
      filterAlternativeOffers: true,
    },
  ];
};
